<div class="modal-header">
  <h5 class="modal-title" id="modal-basic-title">
    {{ 'players.player.addQuickPlayer' | translate }}
  </h5>
  <button type="button" class="btn-close" [disabled]="isSubmitting()" (click)="closeModal()"></button>
</div>

@if (quickPlayerForm) {
  <form class="form theme-form" [formGroup]="quickPlayerForm" (ngSubmit)="onSubmit()">
    <div class="modal-body">
      <div class="row g-2">
        <div class="form-group col-md-6">
          <label for="username" class="form-label">
            {{ 'players.player.username' | translate }}
            <span class="text-danger">*</span>
          </label>
          <input
            type="text"
            id="username"
            formControlName="username"
            class="form-control"
            appLowercase />
          <shared-form-field-error
            [control]="quickPlayerForm.get('username')"
            [errorMessages]="{ required: 'words.requiredField' }">
          </shared-form-field-error>
        </div>

        <div class="form-group col-md-6">
          <label for="email" class="form-label">
            {{ 'userManagement.users.email' | translate }}
            <span class="text-danger">*</span>
          </label>
          <input
            type="email"
            id="email"
            formControlName="email"
            class="form-control" />
          <shared-form-field-error
            [control]="quickPlayerForm.get('email')"
            [errorMessages]="{
              email: 'words.invalidEmail',
              required: 'words.requiredField',
            }">
          </shared-form-field-error>
        </div>

        <div class="form-group col-md-12">
          <label for="mobileNumber" class="form-label">
            {{ 'userManagement.users.mobileNumber' | translate }}
            <span class="text-danger">*</span>
          </label>
          <input
            type="text"
            id="mobileNumber"
            formControlName="mobileNumber"
            class="form-control"
            sharedPhoneInput />
          <shared-form-field-error
            [control]="quickPlayerForm.get('mobileNumber')"
            [errorMessages]="{
              invalidPhoneNumber: 'words.invalidPhoneNumber',
              required: 'words.requiredField',
            }">
          </shared-form-field-error>
        </div>

        <div class="form-group col-md-6">
          <label for="password" class="form-label">
            {{ 'players.player.password' | translate }}
            <span class="text-danger">*</span>
          </label>
          <div class="password-wrapper">
            <input
              id="password"
              formControlName="password"
              class="form-control"
              [type]="showPassword() ? 'text' : 'password'" />
            <i
              class="fas fa"
              [class.fa-eye]="showPassword()"
              [class.fa-eye-slash]="!showPassword()"
              (click)="togglePasswordVisibility()"></i>
          </div>
          <shared-form-field-error
            [control]="quickPlayerForm.get('password')"
            [errorMessages]="{
              required: 'players.player.passwordRequired',
              minlength: 'players.player.passwordMinLength',
              maxlength: 'players.player.passwordMaxLength',
            }"
            [errorParams]="{
              minlength: { min: PLAYER_REGISTER_VALIDATIONS.PASSWORD.MIN_LENGTH },
              maxlength: { max: PLAYER_REGISTER_VALIDATIONS.PASSWORD.MAX_LENGTH },
            }">
          </shared-form-field-error>
        </div>

        <div class="form-group col-md-6">
          <label for="confirmPassword" class="form-label">
            {{ 'players.player.confirmPassword' | translate }}
            <span class="text-danger">*</span>
          </label>
          <div class="password-wrapper">
            <input
              id="confirmPassword"
              formControlName="confirmPassword"
              class="form-control"
              [type]="showConfirmPassword() ? 'text' : 'password'" />
            <i
              class="fas fa"
              [class.fa-eye]="showConfirmPassword()"
              [class.fa-eye-slash]="!showConfirmPassword()"
              (click)="toggleConfirmPasswordVisibility()"></i>
          </div>
          <shared-form-field-error
            [control]="quickPlayerForm.get('confirmPassword')"
            [errorMessages]="{ required: 'words.requiredField' }">
          </shared-form-field-error>
          @if (
            quickPlayerForm.errors?.['mismatch'] &&
            quickPlayerForm.get('confirmPassword')?.touched
          ) {
            <div class="text-danger">
              <small>{{ 'players.player.passwordMismatch' | translate }}</small>
            </div>
          }
        </div>

        @if (canSelectAgent) {
          <div class="form-group col-md-12">
            <label for="agentId" class="form-label">
              {{ 'transfer.agent' | translate }}
              <span class="text-danger">*</span>
            </label>
            <ng-select
              id="agentId"
              formControlName="agentId"
              bindLabel="label"
              bindValue="value"
              [items]="users$ | async"
              [placeholder]="'transfer.placeholders.selectAgent' | translate"
              (search)="onSearchSelect(NG_SELECT_QUERIES.USERS, $event.term)"
              (clear)="onSearchSelect(NG_SELECT_QUERIES.USERS)"
              (close)="onSearchSelect(NG_SELECT_QUERIES.USERS)"
              (scrollToEnd)="onScrollToEndSelect(NG_SELECT_QUERIES.USERS)"></ng-select>
            <shared-form-field-error
              [control]="quickPlayerForm.get('agentId')"
              [errorMessages]="{ required: 'words.requiredField' }">
            </shared-form-field-error>
          </div>
        }
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-danger" [disabled]="isSubmitting()" (click)="closeModal()">
        {{ 'btn.cancel' | translate }}
      </button>
      <button type="submit" class="btn btn-secondary" [disabled]="isSubmitting()">
        @if (isSubmitting()) {
          <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
        }
        {{ 'btn.save' | translate }}
      </button>
    </div>
  </form>
}
